/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { Task, task } from 'ember-concurrency';

interface CioConfirmModalButtonArgs {
  buttonLabel: string;
  buttonClassNames?: string;
  modalTitle: string;
  buttonIcon?: string;
  confirmLabel: string;
  confirmButtonClassNames?: string;
  confirmingLabel: string;
  confirmButtonDisabled?: boolean;
  confirmAction: () => unknown;
  isDisabled?: boolean;
  confirmTask?: Task<void, []>;
}

export default class CioConfirmModalButton extends Component<CioConfirmModalButtonArgs> {
  @tracked showModal = false;

  get isDisabled() {
    return this.args.isDisabled ?? false;
  }

  get buttonClassNames() {
    return this.args.buttonClassNames ?? 'is-danger';
  }

  get confirmButtonClassNames() {
    return this.args.confirmButtonClassNames ?? 'is-danger';
  }

  get confirmButtonDisabled() {
    return this.args.confirmButtonDisabled ?? false;
  }

  realConfirmTask = task({ drop: true }, async () => {
    // try to use confirmTask from args, fallback to default logic:
    if (this.args.confirmTask != null) {
      return this.args.confirmTask.perform();
    }

    try {
      await this.args.confirmAction?.();
    } catch (e) {
      // Ignore promise failure
    } finally {
      this.showModal = false;
    }
  });

  @action
  closeModal() {
    if (this.realConfirmTask.isIdle) {
      this.showModal = false;
    }
  }
}
